import React from "react";
import ColorPicker from "../../utils/ColorPicker";

function WpRssProperties(props) {
  const styleOptions = [
    "Main Content",
    "Main Content (No Transition)",
    "Bottom Content",
  ];

  return (
    <div>
      <div className="addslidesectiontopbar">Style</div>
      <div className="addslidesection grid-fit-2">
        <label>Display Type:</label>
        <select
          value={props.slide.wp_rss_type}
          onChange={(e) => {
            props.updateSlide("wp_rss_type", e.target.value);
          }}
        >
          {styleOptions.map((item) => {
            return (
              <option key={item} value={item}>
                {item}
              </option>
            );
          })}
        </select>
        <label>Font colour:</label>
        <ColorPicker
          color={props.slide.wp_rss_text_colour}
          onChange={(color, e) =>
            props.updateSlide("wp_rss_text_colour", color.hex)
          }
        />
      </div>
      <div className="addslidesectiontopbar">Content</div>
      <div className="addslidesection grid-fit-2">
        <label>URL to RSS feed:</label>
        <input
          type="text"
          value={props.slide.wp_rss_url ? props.slide.wp_rss_url : ""}
          onChange={(e) => props.updateSlide("wp_rss_url", e.target.value)}
        />
        <label>Number of items to display:</label>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type="number"
            min="1"
            value={props.slide.wp_rss_items_to_display === 0 ? "" : props.slide.wp_rss_items_to_display}
            onChange={(e) => {
              const valueStr = e.target.value;
              if (valueStr === "") {
                props.updateSlide("wp_rss_items_to_display", 1); // Default to 1 if cleared
              } else {
                const num = parseInt(valueStr, 10);
                if (!isNaN(num) && num >= 1) {
                  props.updateSlide("wp_rss_items_to_display", num);
                }
              }
            }}
            disabled={props.slide.wp_rss_items_to_display === 0}
            style={{ marginRight: '10px', width: '80px' }}
          />
          <input
            type="checkbox"
            id="displayAllWpRssItems"
            checked={props.slide.wp_rss_items_to_display === 0}
            onChange={(e) => {
              props.updateSlide("wp_rss_items_to_display", e.target.checked ? 0 : 1);
            }}
            style={{ marginRight: '5px' }}
          />
          <label htmlFor="displayAllWpRssItems">Display all</label>
        </div>
        <label>
          Time per item (s): (Optional. If blank, uses total slide duration or a default)
        </label>
        <input
          type="text"
          value={
            props.slide.wp_rss_transition_delay
              ? props.slide.wp_rss_transition_delay
              : ""
          }
          onChange={(e) =>
            props.updateSlide("wp_rss_transition_delay", e.target.value)
          }
        />
      </div>
    </div>
  );
}

export default WpRssProperties;
